// Zoom configuration constants
export const ZOOM_CONFIG = {
  min: 0.05,
  max: 15,
  factor: 1.15,
} as const;

// Layout configuration constants
export const LAYOUT_CONFIG = {
  // SVG canvas dimensions
  svgWidth: 1200,
  svgHeight: 600,

  // Node dimensions
  baseNodeHeight: 150, // Maximum height for the largest bar
  nodeWidth: 8, // Width of vertical bars

  // Horizontal positioning
  sourceNodesX: 350, // X position for source nodes on the left
  rightMargin: 200, // Distance from right edge for target nodes

  // Vertical spacing between bars (adaptive based on source count)
  spacing: {
    low: 48, // For ≤20 sources
    medium: 32, // For 21-30 sources
    high: 48, // For 31-60 sources
  },

  // Height scaling factors based on source count
  heightMultipliers: {
    veryHigh: 0.5, // For >30 sources - most compact
    high: 0.6, // For 21-30 sources
    medium: 0.8, // For 11-20 sources
    low: 0.7, // For ≤10 sources
  },

  // Minimum heights (in pixels) to prevent invisible bars
  minHeights: {
    veryHigh: 1, // For >30 sources
    high: 2, // For 21-30 sources
    medium: 4, // For 11-20 sources
    low: 8, // For ≤10 sources
  },

  // Source count thresholds for adaptive layout
  thresholds: {
    veryHigh: 30, // Transition to most compact layout
    high: 20, // Transition to high density layout
    medium: 15, // Threshold for label text truncation
    low: 10, // Threshold for spacing changes
    maxLabels: 60, // Maximum sources to show labels for
  },

  // Label card configuration
  labelCard: {
    minWidth: 170, // Minimum width for label cards
    leftPaddingLarge: 38, // Padding for wide labels
    leftPaddingSmall: 12, // Padding for narrow labels
    rightPadding: 12, // Right padding for all labels
    offsetX: 10, // Horizontal offset from source node
    heightLarge: 44, // Height for ≤15 sources
    heightSmall: 40, // Height for >15 sources
    charWidthLarge: 5.5, // Character width estimate for >15 sources
    charWidthSmall: 4.7, // Character width estimate for ≤15 sources
    truncationLarge: 35, // Max characters for >15 sources
    truncationSmall: 45, // Max characters for ≤15 sources
  },

  // Vertical positioning
  topOffset: 80, // Offset from top of SVG for first node

  // Tooltip positioning
  tooltipOffset: 16, // Pixels offset from cursor
} as const;
